export const googleMapKey = 'AIzaSyAEY5R902_gyPQQ8QqJiDe-rpu2x6naPDw';

export const baiduMapKey = 'AHhuZYMICxW77crUSHtYnzEF25ADM3bO';

export interface ZoomLevelMapping {
    distanceRange: [number, number]; // 距离范围
    zoomLevel: number; // 缩放级别
}

export const zoomLevelMappings: ZoomLevelMapping[] = [
    { distanceRange: [0, 100], zoomLevel: 18 },
    { distanceRange: [101, 1000], zoomLevel: 16 },
    { distanceRange: [1001, 5000], zoomLevel: 15 },
    { distanceRange: [5001, 10000], zoomLevel: 11 },
    { distanceRange: [10001, 50000], zoomLevel: 10 },
    { distanceRange: [50001, 100000], zoomLevel: 8 },
    { distanceRange: [100001, 1000000], zoomLevel: 6 },
    { distanceRange: [1000001, 5000000], zoomLevel: 4 },
    { distanceRange: [5000001, Infinity], zoomLevel: 2 },
];
